import React, { useState, useEffect, useCallback, useMemo, useRef, useLayoutEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
//import { useNavigate, createSearchParams } from 'react-router-dom';
import { useSearchRecipes, useDeleteRecipe, useFullRecipe, useGetSort, useSaveRecipe } from '../../../hooks/useRecipes';
import { useLibrary } from '../../../hooks/useStaticData';
import { SideFilter, Recipe, ModalWindow, ModalInfo, CounterPage, SceletonRecipe, Popup } from '../../organisms';
import { Selectdisign, SearchRecipe, FormAddRecipe } from '../../molecules';
import { sorts, recipeErrors } from '../../../constants/constants.js';
import { filtrSearchArr, hasLatinLetters, transliterate } from '../../../utils/utils.js'
import './Recipes.css';
import { useHistory } from 'react-router-dom' 

// Константы
const LIMIT = 15;
const DEBOUNCE_DELAY = 800; // 800ms задержка для поиска

export function Recipes({ loggedIn, handleAddRecipeinMeals }) { 
  //const navigate = useNavigate();
  const sortRef = useRef();
  const searchParamss = new URLSearchParams();
  const queryString = searchParamss.toString();
  let history = useHistory() 
  const debounceTimerRef = useRef(null); 
  const { currentUser } = useSelector(state => state.currentUser);   
  const [currentPage, setCurrentPage] = useState(1);
  const [keyword, setKeyword] = React.useState('') 
  const [localCalories, setLocalCalories] = React.useState({}) 
  const [localTimes, setLocalTimes] = React.useState({}) 
  const [selectedIngredients, setSelectedIngredients] = useState([]);
  const [sort, setSort] = useState(sorts[0]);
  const [searchError, setSearchError] = useState('');
  const [transliteratedValue, setTransliteratedValue] = useState('');
  const [userId, setUserId] = React.useState('') 
  const [showModal, setShowModal] = React.useState(false) // Показывает информацию(ошибки или успешные действия с сервером)
  const [textsucces, setTextsucces] = React.useState(''); // Текст для ошибки 
  const [iconVisual, setIconVisual] = React.useState(false); //Иконка для ошибки 

    // Состояние UI
  const [filters, setFilters] = useState({
    type: [],
    category: [],
    kitchenware: [],
    statusFilter: { owner: false, likes: false, feast: false },
    minCalories: '',
    maxCalories: '',
    minTime: '',
    maxTime: '',
    searchKeyword: '',
  });
  const [ui, setUi] = useState({
    isSortOpen: false,
    isFilterOpen: false,
    isAnimating: false,
    isEditOpen: false,
    searchClick: false, //триггер поиска по времени и калориям
    showDeleteConfirm: false,
    editingRecipe: null,
    searchError: '',
    searchSuggest: '',
  });
 
   // 🔥 Флаг для первого рендера
  const isInitialized = useRef(false);

  // 🔥 React Query - данные рецептов
  const searchParams = useMemo(() => ({
    currentPage,
    limit: LIMIT,
    sorter: sort.nameEn,
    userId: currentUser?._id || '', 
    owner: filters?.statusFilter?.owner,
    like: filters?.statusFilter?.likes,
    minCalories: filters.minCalories,
    maxCalories: filters.maxCalories,
    minTime: filters.minTime,
    maxTime: filters.maxTime, 
    feast: filters?.statusFilter?.feast,
    searchWords: filters.searchKeyword, 
    types: filters.type.filter(t => t.boolean).map(t => t._id),
    dishes: filters.category.filter(c => c.boolean).map(c => c.nameRu),
    kitchenware: filters.kitchenware.filter(k => k.boolean).map(k => k._id),
    user: userId,
    moderator: currentUser._id ?  currentUser.supervisor : false
  }), [currentPage, filters, sort, selectedIngredients, currentUser, userId]);
  
  const { recipes, totalCount, isLoading, isFetching, isSuccess, error} = useSearchRecipes(searchParams);
  const { mutate: deleteRecipe } = useDeleteRecipe(searchParams);
  const { data: fullRecipe, isLoading: isFullLoading } = useFullRecipe(ui.editingRecipe?._id); 
  const { data: lib, isLoading: libraryLoading, isSuccess: isSuccessLib} = useLibrary();
  const { data: edge, isLoading: isEdgeLoading }  = useGetSort();
  const totalPages = Math.ceil(totalCount / LIMIT);
  const pages = useMemo(() => Array.from({ length: totalPages }, (_, i) => i + 1), [totalPages]);
 
 
// ========== 1. ИНИЦИАЛИЗАЦИЯ ФИЛЬТРОВ (один раз) ==========
  useEffect(() => { 
    if (libraryLoading) return;
    if (isInitialized.current) return; // Уже инициализировали
    
    // Если нет в URL, пробуем из localStorage
    const saved = JSON.parse(localStorage.getItem('localFilters'));
    if (saved && saved.type?.length) {
      console.log('🔄 Инициализация из localStorage');
      setFilters({
        type: saved.type,
        category: saved.category || [],
        kitchenware: saved.kitchenware || [],
        statusFilter: saved.statusFilter || { owner: false, likes: false, feast: false },
        minCalories: '',
        maxCalories: '',
        minTime: '',
        maxTime: '',
        searchKeyword: '',
      });
      isInitialized.current = true;
      return;
    }
    
    // Если ничего нет - из библиотеки
    console.log('🔄 Инициализация из библиотеки');
    setFilters({
      type: lib.dietTypes || [],
      category: lib.dishTypes || [],
      kitchenware: lib.kitchenware || [],
      statusFilter: { owner: false, likes: false, feast: false },
      minCalories: '',
      maxCalories: '',
      minTime: '',
      maxTime: '',
      searchKeyword: '',
    });
    isInitialized.current = true;
    
  }, [libraryLoading, lib]); // Зависимости только для загрузки lib
  
  // ========== 2. СОХРАНЕНИЕ ФИЛЬТРОВ (только после инициализации) ==========
  useEffect(() => {
    // Пропускаем, если еще не инициализировали
    if (!isInitialized.current) return;
    
    console.log('💾 Сохранение фильтров в URL и localStorage');
    
    // Обновляем URL
    const params = new URLSearchParams();
    filters?.type?.forEach(t => t.boolean && params.append('types[]', t._id));
    filters?.category?.forEach(c => c.boolean && params.append('dishes[]', c.nameRu));
    filters?.kitchenware?.forEach(k => k.boolean && params.append('kitchenware[]', k._id));
    params.append('owner', filters?.statusFilter?.owner);
    params.append('like', filters?.statusFilter?.likes);
    params.append('feast', filters?.statusFilter?.feast);
    
    // Используем replace вместо push, чтобы не создавать лишнюю историю 
      history.push({
    pathname: '/recipes/',
    search: queryString ? `?${queryString}` : ''
  }); 
    
    // Сохраняем в localStorage
    localStorage.setItem('localFilters', JSON.stringify({
      type: filters.type,
      category: filters.category,
      kitchenware: filters.kitchenware,
      statusFilter: filters.statusFilter,
    }));
    
  }, [filters]); // Зависимость от filters
  
  // Scroll to top on page change
useEffect(() => {
  // Сначала прокручиваем
  window.scrollTo({ top: 0 });
  
  // Если данные еще грузятся, повторяем после загрузки
  if (isLoading) {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 200);
    return () => clearTimeout(timer);
  }
}, [currentPage, isLoading]);
  
  useEffect(() => {
    if (error) {  
      const status = error.message.status || error.response?.status || error.message?.match(/\d+/)?.[0];
        setShowModal(true);
        setIconVisual(false);
        setTextsucces(recipeErrors[status] || "Неизвестная ошибка, попробуйте позже, рецепт сохранен в черновиках");
    }
  },[error]);
   

  // Click outside для сортировки
  useEffect(() => {
    const handleClick = (e) => {
      if (ui.isSortOpen && sortRef.current && !sortRef.current.contains(e.target) && !e.target.classList.contains('gg-sorting') && !e.target.classList.contains('select-item' ) ) { 
        setUi(prev => ({ ...prev, isSortOpen: false }));
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [ui.isSortOpen]);
  
  // Body scroll lock
  useEffect(() => {
    document.body.style.overflow = ui.isFilterOpen || ui.isEditOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [ui.isFilterOpen, ui.isEditOpen]);
  
  // Обработчики
  const updateFilters = useCallback((updates) => {
    setFilters(prev => ({ ...prev, ...updates }));
    setCurrentPage(1);
  }, []);
  
  const handleChoiceType = useCallback((e) => {
    const { name, checked } = e.target;
    updateFilters({
      type: filters.type.map(t => t.nameEn === name ? { ...t, boolean: checked } : t)
    });
  }, [filters.type, updateFilters]);
  
  const handleChoiceCategory = useCallback((e) => {
    const { name, checked } = e.target;
    updateFilters({
      category: filters.category.map(c => c.nameEn === name ? { ...c, boolean: checked } : c)
    });
  }, [filters.category, updateFilters]);
  
  const handleChoiceTools = useCallback((e) => {
    const { name, checked } = e.target;
    updateFilters({
      kitchenware: filters.kitchenware.map(k => k.nameEn === name ? { ...k, boolean: checked } : k)
    });
  }, [filters.kitchenware, updateFilters]);
  
  const handleChoiceOwner = useCallback((key, checked) => {
    updateFilters({
      statusFilter: { ...filters.statusFilter, [key]: checked }
    });
  }, [filters.statusFilter, updateFilters]);
  
  const handleCalChange = useCallback((e) => {
  const { name, value } = e.target;
  // Сохраняем в локальное состояние, но не отправляем запрос
  setLocalCalories(prev => ({
    ...prev,
    [name === 'cals-min' ? 'min' : 'max']: value
  }));
}, []);
  
const handleCalBlur = useCallback(() => {
  // При потере фокуса отправляем запрос
  updateFilters({
    minCalories: localCalories.min,
    maxCalories: localCalories.max,
    minTime: localTimes.minTime,
    maxTime: localTimes.maxTime,
  });
}, [localCalories, localTimes]);

  const handleTimeChange = useCallback((e) => {
  const { name, value } = e.target;
  // Сохраняем в локальное состояние, но не отправляем запрос
  setLocalTimes(prev => ({
    ...prev,
    [name === 'time-min' ? 'minTime' : 'maxTime']: value
  }));
}, []);

 
  
  const handleReset = useCallback(() => {
    setFilters({
      type: lib?.dietTypes.map(prev => ({ ...prev,  boolean: false})),
      category: lib?.dishTypes.map(prev => ({ ...prev,  boolean: false})),
      kitchenware: lib?.kitchenware.map(prev => ({ ...prev,  boolean: false})),
      statusFilter: { owner: false, likes: false, feast: false },
      minCalories: '',
      maxCalories: '',
      minTime: '',
      maxTime: '',
      searchKeyword: '',
    });
    setLocalCalories({minCalories: '', maxCalories: ''});
    setLocalTimes({minTime: '', maxTime: ''});
    setSelectedIngredients([]);
    setCurrentPage(1);
    localStorage.removeItem('localFilters');
  }, [lib]);
  
  
    // 🔥 Debounced поиск
  const debouncedSearch = useCallback((value) => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    
    debounceTimerRef.current = setTimeout(() => {
      setFilters(prev => ({ ...prev, searchKeyword: value }));
      
    }, DEBOUNCE_DELAY);
  }, []);

   
  // Обработка ввода с проверкой на латиницу и транслитерацией 
  function handleSearchInput(e) { 
    let value = e.target.value;
    setKeyword(value) 
    
    
    // Проверка на латиницу
    if (hasLatinLetters(value)) {
      setSearchError('Используйте кириллицу для поиска');
      setTransliteratedValue(transliterate(value));
      return;
    }
    
    // Очищаем ошибку
    setSearchError('');
    setTransliteratedValue('');
    if(!hasLatinLetters(value)) {
      // Debounced поиск рецептов
      debouncedSearch(value);
    } 
  }


  const applyTransliteration = () => {
    if (transliteratedValue) { 
      const syntheticEvent = { target: { value: transliteratedValue } };
      handleSearchInput(syntheticEvent);
      setTransliteratedValue('');
      setSearchError('');
    }
  };
 
  // Очистка таймера при размонтировании
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  const handleEdit = useCallback((recipe) => {
    setUi(prev => ({ ...prev, isEditOpen: true, editingRecipe: recipe }));
  }, []);
  
  const handleDelete = useCallback((recipe) => {
    setUi(prev => ({ ...prev, showDeleteConfirm: true, editingRecipe: recipe }));
  }, []);
  
  const confirmDelete = useCallback(() => {
    deleteRecipe(ui.editingRecipe._id);
    setUi(prev => ({ ...prev, showDeleteConfirm: false, editingRecipe: null }));
  }, [deleteRecipe, ui.editingRecipe]);
  
  const handleSortChange = useCallback((newSort) => { 
    setSort(newSort); 
  }, []);
  
  const handleCalsClick = useCallback(() => {
    setUi(prev => ({ ...prev, searchClick: !prev.searchClick }));
  }, []);

  
  const toggleSort = useCallback(() => {
    setUi(prev => ({ ...prev, isSortOpen: !prev.isSortOpen }));
  }, []);
  
  const toggleFilter = useCallback(() => {
    setUi(prev => ({ ...prev, isFilterOpen: !prev.isFilterOpen }));
  }, []);
  
  const closeModal = useCallback(() => {
    setUi(prev => ({ ...prev, isEditOpen: false, showDeleteConfirm: false, editingRecipe: null }));
  }, []);
  
 
//   if (error) return <div className="error">Ошибка: {error.message.status}</div>;
  const handleSaveSuccess = (savedRecipe) => { 
    
    // Можно показать уведомление
    console.log('Рецепт обновлен:', savedRecipe.nameRu);
    
    // React Query автоматически обновит список
    // потому что в useSaveRecipe мы вызвали invalidateQueries
  };
  
  function handleChangeInputId(e) { 
  setCurrentPage(1)
  setUserId(e.target.value)   
  
}

    function handlerCloseError() {
    setShowModal(false);
  }
  console.log(isLoading, isSuccess, isFetching)
  return (
    <>
      <title>Рецепты для плана питания 🍳 | MENUBOOK</title>
      <meta name="description" content="Подберите рецепты для плана питания с фильтрами по калориям, времени и диетам." />
      
      <div className={`recipes ${isLoading ? 'loading' : ''}`}>
        {/* Десктопные фильтры */}
        <div className='filter filter__deckstop'>
          <h3 className='font26EB color filter__title'>Фильтры</h3>
          
          <SideFilter
            type={filters.type}
            category={filters.category}
            kitchenware={filters.kitchenware}
            handleChoiceType={handleChoiceType}
            handleChoiceCategory={handleChoiceCategory}
            handleChoiceTools={handleChoiceTools}
            value={filters.statusFilter}
            handleChoiceOwner={handleChoiceOwner}
            handleReset={handleReset}
            handleCalChange={handleCalChange}
            handleTimeChange={handleTimeChange}
            minCalories={filters.minCalories}
            maxCalories={filters.maxCalories}
            minTime={filters.minTime}
            maxTime={filters.maxTime}
            edge={edge}
            fetching={isLoading}
            calsClick={handleCalBlur}
          />  
        </div>
        
        <div className='df-c relative widt100 g50'>
          {/* Поиск и сортировка */}
           <div className='searching '>
            <div className='search search__mobile'> 
            <SearchRecipe
              keyword={keyword}
              transliteratedValue={transliteratedValue}
              handleChangeInput={handleSearchInput}
              error={searchError}
              applyTransliteration={applyTransliteration}
              choiceIngredient={selectedIngredients}
              filtrMassiv={[]}  
              userId={userId}
              hidden={false}
              handleChangeInputId={handleChangeInputId}
              hiddenClose={() => {}}
            />
          
            </div>
            <div className='sort df-r g20'>
              <button className='filter__mobile-button gg-filter' onClick={toggleFilter} />
              <button className='filter__mobile-button gg-sorting' onClick={toggleSort}>
                <Popup isOpen={ui.isSortOpen} ref={sortRef} type='sort'>
                  {sorts.map(el => (
                    <p key={el.nameEn} onClick={() => handleSortChange(el)}>
                      {el.nameRu}
                    </p>
                  ))}
                </Popup>
              </button>
              <Selectdisign data={sorts} name={sort} ref={sortRef} isOpen={ui.isSortOpen} handlePopupModal={toggleSort}  handleChangeEvents={handleSortChange}/>
            </div>
          </div>
          {/* Список рецептов */}
          <ul className='cards'>
            {isFetching && !isLoading ? <SceletonRecipe /> :
            recipes.map(recipe => (
              <Recipe
                key={recipe._id}
                recipe={recipe}
                handleEditRecipe={handleEdit}
                loggedIn={loggedIn}
                handleDeleteRecipe={handleDelete}
                type='recipe'
                handleAddRecipeinMeals={handleAddRecipeinMeals}
              />
            ))}
            {!isLoading && isSuccess && recipes.length === 0 && (
              <div className='recipe_none'>
                <p className='gg-no-dish' />
                <p>Ничего не найдено</p>
              </div>
            )}
          </ul>
          
          {/* Пагинация */}
          {totalPages > 1 && (
            <CounterPage
              pages={pages}
              currentPage={currentPage}
              handleCounter={setCurrentPage}
              totalCount={totalCount}
            />
          )}
          
        
        </div>
        
        {/* Мобильные фильтры */}
        {ui.isFilterOpen && (
          <div className={`modal-overlay ${ui.isAnimating ? 'closing' : ''}`} onClick={() => setUi(prev => ({ ...prev, isFilterOpen: false }))}>
            <div className="modal-side" onClick={e => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Фильтры</h3>
                <button onClick={() => setUi(prev => ({ ...prev, isFilterOpen: false }))}>×</button>
              </div>
              <SideFilter
                type={filters.type}
                category={filters.category}
                kitchenware={filters.kitchenware}
                handleChoiceType={handleChoiceType}
                handleChoiceCategory={handleChoiceCategory}
                handleChoiceTools={handleChoiceTools}
                value={filters.statusFilter}
                handleChoiceOwner={handleChoiceOwner}
                handleReset={handleReset}
                handleCalChange={handleCalChange}
                handleTimeChange={handleTimeChange}
                minCalories={filters.minCalories}
                maxCalories={filters.maxCalories}
                minTime={filters.minTime}
                maxTime={filters.maxTime}
                edge={edge}
                calsClick={handleCalBlur}
                fetching={isLoading ? 'loading' : 'resolved'}
              />
            </div>
          </div>
        )}
        
        {/* Модальное окно редактирования */}
        {ui.isEditOpen && (
          <ModalWindow onClose={closeModal} title='edit-recipe' head='Редактировать рецепт'>
            {isFullLoading ? <div>Загрузка...</div> : (
              <FormAddRecipe card={fullRecipe || ui.editingRecipe} onClose={closeModal} isOpen={ui.isEditOpen} onSuccess={handleSaveSuccess} />
            )}
          </ModalWindow>
        )}
        
        {/* Модальное окно подтверждения удаления */}
        {ui.showDeleteConfirm && (
          <ModalInfo onClose={closeModal} name='choice-delete' textError={`Удалить рецепт "${ui.editingRecipe?.name}"?`}  >
            <div className="g10 flexRowCenter">
              <button onClick={confirmDelete} className="buttonGrey">Да</button>
              <button onClick={closeModal} className="buttonGreen">Нет</button>
            </div>
          </ModalInfo>
        )}
        {/*Модальное окно ошибки */
              showModal &&
                <ModalInfo onClose={handlerCloseError} textError={textsucces} icon={iconVisual} name="modal-info" />
              }
      </div>
    </>
  );
}
 